import gql from 'graphql-tag';

import {
  printProductSizeRoesGraphicNodeDetails,
  printProductSizeServiceDetails,
} from '../../../../../../../graphql/fragments/print-product';
import { printPartnerOrderServiceDetails } from '../../../../../../../graphql/fragments/print-partner';
import { VendorDetails } from '../../../../../../../graphql/fragments/account';
import printProductSizeBaseDetails from './printProductSizeBaseDetails';
import { DigitalBundleDetails } from '../../../../../../../graphql/fragments/digital-bundles';

const albumMembershipGroupPrintPackages = gql`
  fragment albumMembershipGroupPrintPackages on AlbumMembershipGroup {
    id
    print_packages {
      ... on IHierarchyPrintPackage {
        id
        type
        print_package {
          id
          name
          max_checkout_items
          is_multi_pose
          is_multi_identity
          preview_asset_image {
            id
            url
          }
          account {
            ...VendorDetails
          }
          price(album_folder_id: $album_folder_id) {
            value
            currency
          }
          discount_price {
            value
            currency
          }
          digital_downloads_mode
          digital_downloads_upsell_price {
            value
            currency
          }
          print_package_bundle_discount_price {
            value
            currency
          }
          print_assets(slice: { limit: 999 }) {
            total
            records {
              id
              print_asset {
                id
                name
                type
                jersey_colors(slice: { limit: 999 }) {
                  records {
                    id
                    jersey_color
                  }
                }
                asset_image {
                  id
                  url
                  width
                  height
                }
              }
            }
          }
          jersey_colors(slice: { limit: 999 }) {
            total
            records {
              id
              jersey_color
            }
          }
          print_order_configuration {
            print_partner_order_services {
              total
              records {
                id
                print_partner_order_service {
                  ...printPartnerOrderServiceDetails
                }
              }
            }
            total_price {
              value
              currency
            }
          }
          items(slice: { limit: 99 }) {
            total
            records {
              id
              quantity
              type {
                id
                name
              }
              album_folder_tag {
                ... on CustomAlbumFolderTag {
                  id
                  name
                }
              }
              price {
                value
                currency
              }
              discount_price {
                value
                currency
              }
              is_optional
              custom_print {
                id
                name
                type
                subtype
                preview_image {
                  id
                  url
                }
                photos_no
                background_image {
                  id
                  url
                }
                account {
                  id
                  logo_image {
                    id
                    url
                  }
                }
                price {
                  value
                  currency
                }
                custom_print_caption_enabled
                shipping_required
                shipping_enabled
                card {
                  id
                  card_side_groups {
                    records {
                      id
                      side
                      card_sides {
                        records {
                          id
                          card_template {
                            id
                            orientation
                            print_product {
                              id
                              print_partner {
                                id
                                name
                              }
                              print_size {
                                id
                              }
                              sizes(slice: { limit: 999 }) {
                                records {
                                  id
                                  sku
                                  print_size {
                                    id
                                    name
                                  }
                                }
                              }
                            }
                            print_size {
                              id
                              name
                              width
                              height
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              print_product_configuration {
                print_product {
                  id
                  name
                  is_standard
                  preview_asset_image {
                    id
                    url
                  }
                  card {
                    id
                  }
                }
                print_product_size {
                  ...printProductSizeBaseDetails
                }
                print_product_size_services {
                  total
                  records {
                    id
                    print_product_size_service {
                      ...printProductSizeServiceDetails
                    }
                  }
                }
                print_product_size_roes_graphic_node {
                  ...printProductSizeRoesGraphicNodeDetails
                }
              }
              album_folder_print_package_items(slice: { limit: 99 }) {
                total
                records {
                  id
                  album_folder_print_package {
                    album_folder {
                      id
                    }
                  }
                  price {
                    value
                    currency
                  }
                  discount_price {
                    value
                    currency
                  }
                  album_folder_tag {
                    ... on CustomAlbumFolderTag {
                      id
                      name
                    }
                  }
                }
              }
              digital_bundle {
                ...DigitalBundleDetails
              }
              grants_purchased_identity
            }
          }
        }
      }
      ... on HierarchyAlbumFolderPrintPackage {
        album_folder {
          id
        }
      }
      ... on HierarchyAlbumPrintPackage {
        album {
          id
        }
      }
    }
  }
  ${printProductSizeBaseDetails}
  ${printProductSizeServiceDetails}
  ${printPartnerOrderServiceDetails}
  ${printProductSizeRoesGraphicNodeDetails}
  ${VendorDetails}
  ${DigitalBundleDetails}
`;

export default albumMembershipGroupPrintPackages;
